// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_swupHooker", inline: true };
const loggerMsgs = {
  initStart: ["init. swupHooker"],
  initSuccess: ["init. swupHooker", "init. success"],
  noValidDOMEl: ["init. swupHooker", "no valid DOM element provided"],
  noSwupInst: ["init. swupHooker", "no swup instance found"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_swupHooker() {
  // Setup...
  const swupInst = window.swupInst;
  const { is_mobile } = this.state;
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  if (!swupInst) return this.logger("error", loggerMsgs.noSwupInst, "error", logArgs);

  /////////////////
  // visit:start //
  /////////////////

  // Hook into visit:start event to preload assets of incoming routes...
  swupInst.hooks.before("visit:start", (VISITDATA) => {
    this.logger("event", ["swup hook", "visit:start"], "event", logArgs);
    return new Promise(async (res) => {
      // Get preload manifest for target route...
      const targetRoute = VISITDATA.to.url == "/" ? "home" : VISITDATA.to.url.split("/").pop();
      const manifest = await this.api.get_preloadManifest(targetRoute);

      // Guard...
      if (!manifest) return res();

      // Load assets for incoming route...
      const filesToLoad = is_mobile ? manifest.mobileFiles : manifest.desktopFiles;
      this.api.load_assets(filesToLoad, { skipFileInsertion: true, storeLoadedItems: true });

      // Create loadQueue completion promise (temporary listener)...
      this.modules.loadQueue.instance.on("complete", () => res());
    });
  });

  /////////////////////
  // content:replace //
  /////////////////////

  // Hook into content:replace event to insert loaded assets...
  swupInst.hooks.on("content:replace", (VISITDATA) => {
    const { loadedItems } = this.state;
    const { pageRevealDelay } = this.options;
    this.logger("event", ["swup hook", "content:replace"], "event", logArgs);

    // Guard...
    if (!loadedItems.length) return;

    // Insert loaded assets...
    loadedItems.forEach((item) => {
      const { uuid, type, objectURL } = item;
      this.api.insert_loadedAsset({ uuid, type, objectURL });
    });

    // – Clear loaded items...
    // - Reset skipFileInsertion & storeLoadedItems flags...
    // - Hide preloader...
    this.setState({ loadedItems: [], loadQueueConfig: { skipFileInsertion: false, storeLoadedItems: false } });
    setTimeout(() => this.api.hideComp(), pageRevealDelay);
  });

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
